const pathOf = (url) => {
  const match = /\/o\/([^?]+)/.exec(url || "");
  if (!match) return "";
  try {
    return decodeURIComponent(match[1]);
  } catch (e) {
    return match[1];
  }
};

export const normalizeFiles = (value, legacyName) => {
  const raw = Array.isArray(value) ? value : value ? [value] : [];
  const seen = new Set();
  return raw.reduce((out, item) => {
    const url = typeof item === "string" ? item : item && item.url;
    if (!url) return out;

    const path = pathOf(url);
    const key = path || url;
    if (seen.has(key)) return out;
    seen.add(key);

    const fromPath = path ? path.split("/").pop() : "";
    const name = (item && item.name) || fromPath || legacyName || "archivo";
    return out.concat({ name, url });
  }, []);
};

/**
 * True si alguna de las listas de antd tiene un archivo todavia subiendo.
 *
 * Se deriva del propio fileList en vez de un flag booleano: con `multiple`
 * las subidas son concurrentes y un flag que cada una pone y quita lo apaga
 * la primera en terminar, dejando enviar mientras el resto sigue en vuelo.
 */
export const haySubidaEnCurso = (...listas) =>
  listas.some(
    (lista) =>
      Array.isArray(lista) && lista.some((f) => f && f.status === "uploading")
  );

/** URL de un item de antd, mirando los tres sitios donde puede estar. */
export const urlDeItem = (file) =>
  (file && file.url) ||
  (file && file.xhr && file.xhr.url) ||
  (file && file.response && file.response.url) ||
  null;

/**
 * Convierte lo guardado en Firestore al formato de fileList de antd Upload,
 * para precargar el control con los archivos que ya tiene el registro.
 */
export const aFileList = (files, prefijo = "old") =>
  files.map((f, i) => ({
    uid: `${prefijo}-${i}`,
    name: f.name,
    status: "done",
    url: f.url,
  }));

/**
 * Convierte el fileList de antd a lo que se guarda en Firestore.
 * Descarta los que no terminaron: un item en error o a medio subir no tiene
 * URL utilizable y guardarlo dejaria una entrada rota en el documento.
 */
export const aCampos = (fileList) =>
  (fileList || [])
    .filter((f) => f.status === "done")
    .map((f) => ({ name: f.name, url: urlDeItem(f) }))
    .filter((f) => f.url);

export default normalizeFiles;
